import React, { useState, useEffect, useContext } from 'react';
import styles from './ConsumerUnit.module.css';

import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import Panel from '../../Components/Panel/Panel';
import PanelListDefault from '../../Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from '../../Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ExecuteAxios from '../../Components/ExecuteAxios/ExecuteAxios';
import ResetVariables from '../../Components/ResetVariables/ResetVariables';
import ApplyAttributes from '../../Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from '../../Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import InputField from '../../Components/Input/InputField';
import MandatoryIconField from '../../Components/MandatoryIconField';
import { AuthContext } from '../../Contexts/auth';
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator';
import { FaList, FaEdit } from 'react-icons/fa';

function ConsumerUnit() {
    const { clientSelected, clientSelectedHandled, setClientSelectedHandled } = useContext(AuthContext);
    const [id, setId] = useState(null)
    const [block, setBlock] = useState(null)
    const [apartment, setApartment] = useState(null)
    const [isActive, setIsActive] = useState('S')

    const [amountFloors, setAmountFloors] = useState(null)
    const [blockAdvanced, setBlockAdvanced] = useState(null)
    const [apartmentsAdvanced, setApartmentsAdvanced] = useState(null)
    const [differenceBetweenFloors, setDifferenceBetweenFloors] = useState(null)

    const [consumerUnitRecords, setConsumerUnitRecords] = useState(null)
    const [consumerUnitRecordDetail, setConsumerUnitRecordDetail] = useState(null)
    const [selectedsConsumerUnits, setSelectsConsumerUnits] = useState([])
    const [inserting, setInserting] = useState(false)
    const [updating, setUpdating] = useState(false)
    const [insertingUnitAdvanced, setInsertingUnitAdvanced] = useState(false)
    const [loadingPanel, setLoadingPanel] = useState(false)
    const [loadingPanelUnitAdvanced, setLoadingPanelUnitAdvanced] = useState(false)
    const [activeTab, setActiveTab] = useState('list');
    const isMobile = window.innerWidth <= 786;

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "block", value: block, setter: setBlock },
        { name: "apartment", value: apartment, setter: setApartment },
        {
            name: "isActive", value: isActive, setter: setIsActive, defaultValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
    ];

    useEffect(() => {
        const fetchData = (async () => {
            await getConsumerUnitDetail(0)
            await getConsumerUnitGrid()
        })

        fetchData()
    }, []);

    useEffect(() => {
        if (!clientSelected || !clientSelectedHandled) return
        setClientSelectedHandled(false)

        const fetchData = (async () => {
            setInserting(false)
            setUpdating(false)
            ResetVariables.resetVariables(attributeList)
            await getConsumerUnitGrid()
        })

        fetchData()
    }, [clientSelectedHandled]);

    useEffect(() => {
        setDetailRecord(selectedsConsumerUnits)
    }, [selectedsConsumerUnits]);

    async function setDetailRecord(selectedsConsumerUnits) {
        if (selectedsConsumerUnits && selectedsConsumerUnits.length === 1) {
            setInserting(false)
            setUpdating(false)
            await getConsumerUnitDetail(selectedsConsumerUnits[0])
        } else {
            setUpdating(false)
            ResetVariables.resetVariables(attributeList)
        }
    }

    async function getConsumerUnitGrid() {
        const parameters = {
            clientId: clientSelected ?? 0,
            isActive: 'S'
        }
        const consumerUnitRecordsResponse = await ExecuteAxios.api('get', `/consumer-unit/get-consumer-unit-active-grid/`, { params: parameters });
        setConsumerUnitRecords(consumerUnitRecordsResponse);
        RemoveIdsNotFound.remove(consumerUnitRecordsResponse, setSelectsConsumerUnits, selectedsConsumerUnits)
    }

    async function getConsumerUnitDetail(selectedConsumerUnits) {
        const parameters = {
            id: selectedConsumerUnits
        }
        const consumerUnitRecordsDetail = await ExecuteAxios.api('get', `/consumer-unit/get-consumer-unit-by-id-detail/`, { params: parameters });
        setConsumerUnitRecordDetail(consumerUnitRecordsDetail);
        if (consumerUnitRecordsDetail) {
            ApplyAttributes.applyAttributes(consumerUnitRecordsDetail, attributeList, inserting)
        }
    }

    async function putConsumerUnit() {
        try {
            setLoadingPanel(true)
            const parameters = {
                id: selectedsConsumerUnits[0],
                clientId: clientSelected ?? 0,
                block: block,
                apartment: apartment,
                isActive: isActive
            }
            return await ExecuteAxios.api('put', `/consumer-unit/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    async function postConsumerUnit() {
        try {
            setLoadingPanel(true)
            const parameters = {
                clientId: clientSelected ?? 0,
                block: block,
                apartment: apartment,
                isActive: isActive
            }
            return await ExecuteAxios.api('post', `/consumer-unit/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    async function postConsumerUnitAdvanced() {
        try {
            setLoadingPanelUnitAdvanced(true)
            const parameters = {
                clientId: clientSelected ?? 0,
                amountFloors: amountFloors,
                block: blockAdvanced,
                apartmentsAdvanced: apartmentsAdvanced,
                differenceBetweenFloors: differenceBetweenFloors,
                isActive: 'S'
            }
            return await ExecuteAxios.api('post', `/consumer-unit/`, parameters);
        } finally {
            setAmountFloors('')
            setBlockAdvanced('')
            setApartmentsAdvanced('')
            setDifferenceBetweenFloors('')
            setLoadingPanelUnitAdvanced(false)
        }
    }

    const mainPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
    };

    const attributeAdvanced = {
        width: '150px'
    };


    return (
        <LayoutDefault>



            {(activeTab === 'list' || !isMobile) && (
                <Panel
                    className={'main-modal two left'}
                    style={mainPanelStyle}
                    titlePage={'Unidades consumidoras'}
                    canViewCRUD={true}
                    recordsSelected={[]}
                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={consumerUnitRecords}
                    attributeList={attributeList}
                    onUpdateIdSelected={setSelectsConsumerUnits}
                >
                    <LoadingIndicator loaded={consumerUnitRecords && !loadingPanel}>
                        <PanelListDefault
                            onUpdateIdSelected={setSelectsConsumerUnits}
                            idsSelected={selectedsConsumerUnits}
                            data={consumerUnitRecords}
                            attributeList={attributeList}
                            selectFirstRecord={true}
                            inserting={inserting}
                            updating={updating}
                        />
                    </LoadingIndicator>
                </Panel>
            )}

            {(activeTab === 'detail' || !isMobile) && (
                <Panel
                    className={'main-modal two right'}
                    style={mainPanelStyle}>
                    <Panel
                        titlePage={'Unidade selecionada'}
                        style={{ height: '50%' }}
                        setUpdating={setUpdating}
                        setInserting={setInserting}
                        inserting={inserting}
                        updating={updating}
                        enableEdit={true}
                        canEdit={selectedsConsumerUnits && selectedsConsumerUnits.length === 1}
                        putFunction={putConsumerUnit}
                        enableNewRecord={true}
                        canNewRecord={true}
                        postFunction={postConsumerUnit}
                        canViewCRUD={true}
                        recordsSelected={[]}
                        viewOnlyOneRecordCRUD={false}
                        resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                        dataListedAttributes={consumerUnitRecords}
                        attributeList={attributeList}
                        onUpdateIdSelected={setSelectsConsumerUnits}
                        reloadFilter={
                            async () => {
                                await getConsumerUnitGrid()
                            }
                        }
                        cancelFunction={
                            async () => {
                                await setDetailRecord(selectedsConsumerUnits)
                            }
                        }
                    >
                        <div style={{ height: 'calc(100% - 56px)' }}>
                            <LoadingIndicator loaded={consumerUnitRecordDetail && !loadingPanel}>
                                <AutomaticallyListedAttributes
                                    list={consumerUnitRecordDetail}
                                    attributeList={attributeList}
                                    readOnlyAttributes={!inserting && !updating}
                                    style={{ height: 'calc(100% - 56px)' }}
                                />
                            </LoadingIndicator>

                        </div>
                    </Panel>
                    <Panel
                        titlePage={'Inserção avançada'}
                        style={{ height: '50%', borderTop: '1px solid #ccc', overflowY: 'auto' }}
                        setInserting={setInsertingUnitAdvanced}
                        inserting={insertingUnitAdvanced}
                        enableNewRecord={true}
                        canNewRecord={true}
                        canSaveAfterNewRecord={amountFloors && apartmentsAdvanced && differenceBetweenFloors}
                        postFunction={postConsumerUnitAdvanced}
                        canViewCRUD={true}
                        readOnly={inserting}
                        recordsSelected={[]}
                        viewOnlyOneRecordCRUD={false}
                        reloadFilter={async () => {
                            await getConsumerUnitGrid()
                        }}
                        cancelFunction={
                            async () => {
                                await setDetailRecord(selectedsConsumerUnits)
                            }
                        }
                    >
                        <div style={{ display: 'flex', maxHeight: 'calc(100% - 56px)', flexWrap: 'wrap' }}>
                            <LoadingIndicator loaded={!loadingPanelUnitAdvanced}>
                                <div className={styles.divAttributes}>
                                    <div className={styles.spanAttributes}>
                                        <span>Quantidade de andares</span>
                                        {<MandatoryIconField />}
                                    </div>
                                    <InputField
                                        setAttribute={setAmountFloors}
                                        value={amountFloors}
                                        readOnly={!insertingUnitAdvanced}
                                        disabled={!insertingUnitAdvanced}
                                        style={attributeAdvanced}
                                    />
                                </div>
                                <div className={styles.divAttributes}>
                                    <div className={styles.spanAttributes}>
                                        <span>Bloco</span>
                                    </div>
                                    <InputField
                                        setAttribute={setBlockAdvanced}
                                        value={blockAdvanced}
                                        readOnly={!insertingUnitAdvanced}
                                        disabled={!insertingUnitAdvanced}
                                        style={attributeAdvanced}
                                    />
                                </div>
                                <div className={styles.divAttributes}>
                                    <div className={styles.spanAttributes}>
                                        <span>Padrão de apartamentos</span>
                                        {<MandatoryIconField />}
                                    </div>
                                    <InputField
                                        setAttribute={setApartmentsAdvanced}
                                        value={apartmentsAdvanced}
                                        readOnly={!insertingUnitAdvanced}
                                        disabled={!insertingUnitAdvanced}
                                        placeholder={'101,102,103,104'}
                                        style={attributeAdvanced}
                                    />
                                </div>
                                <div className={styles.divAttributes}>
                                    <div className={styles.spanAttributes}>
                                        <span>Diferença entre andares</span>
                                        {<MandatoryIconField />}
                                    </div>
                                    <InputField
                                        setAttribute={setDifferenceBetweenFloors}
                                        value={differenceBetweenFloors}
                                        readOnly={!insertingUnitAdvanced}
                                        disabled={!insertingUnitAdvanced}
                                        placeholder={'100 (Exemplo: 101, 201, 301)'}
                                        style={{ ...attributeAdvanced, width: '250px' }}
                                    />
                                </div>
                            </LoadingIndicator>
                        </div>
                    </Panel>
                </Panel>
            )}

            {/* Navegação inferior mobile */}
            {isMobile && (
                <div className={styles.bottomNav}>
                    <button
                        className={`${styles.navButton} ${activeTab === 'list' ? styles.active : ''}`}
                        onClick={() => setActiveTab('list')}
                    >
                        <FaList />
                        <span>Lista</span>
                    </button>
                    <button
                        className={`${styles.navButton} ${activeTab === 'detail' ? styles.active : ''}`}
                        onClick={() => setActiveTab('detail')}
                    >
                        <FaEdit />
                        <span>Detalhe</span>
                    </button>
                </div>
            )}
        </LayoutDefault>
    );
}

export default ConsumerUnit;
